import { ContactShadows } from "@react-three/drei";
import { memo } from "react";

interface BakedContactShadowsProps {
	modelRevision: number;
	/** Surface receiving the shadow, in world metres; never the sauna floor. */
	groundY: number;
	width: number;
	length: number;
	resolution: number;
	blur: number;
	opacity: number;
	color: string;
}

/**
 * One-shot contact-shadow bake, mounted only after the sauna model reports a
 * settled scene revision. Memoization matters here: drei resets its internal
 * frame counter on render, so unrelated parent renders must not restart the
 * depth + blur pass.
 */
export const BakedContactShadows = memo(function BakedContactShadows({
	modelRevision,
	groundY,
	width,
	length,
	resolution,
	blur,
	opacity,
	color,
}: BakedContactShadowsProps) {
	if (modelRevision === 0) return null;

	return (
		<ContactShadows
			key={modelRevision}
			position={[0, groundY + 0.002, 0]}
			scale={Math.max((width + length) / 1000, 6)}
			resolution={resolution}
			blur={blur}
			opacity={opacity}
			far={4}
			frames={1}
			color={color}
		/>
	);
});
